import { Component, inject } from "@angular/core";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { MarketSalesDataService } from "src/services/estate/market-sales-data.service";
import { MarketPriceStatisticsComponent } from "./market-price-statistics/market-price-statistics.component";
import { input } from "@angular/core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";

@Component({
    selector: "price-statistics",
    imports: [EvLogoLoaderComponent, MarketPriceStatisticsComponent],
    templateUrl: "./price-statistics.component.html",
    styleUrl: "./price-statistics.component.scss",
})
export class PriceStatisticsComponent {
    statistics = input.required<StatisticsLine[]>()

    marketSalesDataService: MarketSalesDataService = inject(MarketSalesDataService);

    canShowStatisticsData(): boolean {
        return this.statistics() != null;
    }
}
